module.exports = __webpack_public_path__ + "static/media/4ODA8.be71c0c9.jpg";